'use strict';

export default class EventListController {
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;

  year = new Date().getFullYear();
  yearsToList = 2;
  years = [];

  /*@ngInject*/
  constructor(Events, list, $sce, marked, $state) {
    console.log(list);
    this.list = list;
    this._$sce = $sce;
    this._$state = $state;
    this._$marked = marked;
    this._Events = Events;
  }

  updateMarkdown(input) {
    let renderedHTML = '';
    if(input) {
      renderedHTML = this._$sce.trustAsHtml(this._$marked(input));
    }
    return renderedHTML;
  }

  deleteEvent(event) {
    this._Events.delete(event._id)
        .then(res => {
          console.log('Result', res);
          this.list.splice(this.list.indexOf(event), 1);
        })
        .catch(err => {
          console.log('Error', err);
        });
  }

}



// WEBPACK FOOTER //
// ./client/app/events/list/list.controller.js